<template>
  <v-card>
    <!-- <v-card-title>
      <v-btn icon text @click="getCellsList" v-if="refresh">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer v-if="refresh"></v-spacer>
      <v-select
        v-model="selectedFilter"
        :items="cellFilters"
        filled
        outlined
        hide-details
        dense
        rounded
        class="mr-2"
        multiple
        style="max-width: 340px"
      ></v-select>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        clearable
        dense
        filled
        outlined
        rounded
        style="max-width: 400px"
      ></v-text-field>
    </v-card-title> -->

    <v-data-table 
      :headers="headers"
      :items="cellList"
      :loading="loading"
      :server-items-length="listCount"
      :options.sync="options"
    >
      <template v-slot:item.balancedon="{ item }">
        {{$date.utcToLocal(item.balancedon)}}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn text @click="viewItem(item)" class="mr-1">
          <v-icon small>remove_red_eye</v-icon> View
        </v-btn>
        <v-btn text @click="deleteItem(item)" color="red" v-if="deleteButton">
          <v-icon small>delete</v-icon> Delete
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { balancedcells } from "@/api";
export default {
  name: "BalancedCells",
  props: {
    refresh: {
      type: Boolean,
      default: function() {
        return true
      }
    },
    deleteButton: {
      type: Boolean,
      default: function() {
        return true
      }
    }
  },
  data: () => ({
    
    groupCellsDialog: false,
    loading: false,
    options: {},
    headers: [
			{
				text: 'Cell #',
				align: 'left',
				sortable: false,
				value: 'number',
			},
			{ text: 'Value', value: 'value' },
			{ text: 'Power', value: 'power' },
      { text: 'Average Voltage', value: 'pov'},
      {text:'QR Code',value:'QRCode'},
      {text:'DAQ SN',value:'DAQ_SN'},
      // {text:'Run ID', volume:'Run_ID'},
      // {text:'Serial_Res', value:'Serial_Res'},
			{ text: 'Balanced On', value: 'balancedon' },
			// { text: 'Actions', value: 'action', sortable: false },
    ],
    groupcells: [],
    cellList: [],
    listCount: 0
  }),

  watch: {
    dialog (val) {
      val || this.close()
    },
    options: {
      handler () {
        this.getList()
      },
      deep: true,
    }
  },
  methods: {
    initialize () {
      this.getList()
    },
    async getList() {
      const { page = 1, itemsPerPage = 10 } = this.options
      this.loading = true;
      const response = await balancedcells.search(itemsPerPage, page);
      this.listCount = response.data.count;
      this.cellList = response.data.data;
      this.loading = false;
      console.log(response);
    },



  },
  mounted() {
    this.initialize();
  }
};
</script>